@if (payments) {
<div class="flex flex-middle">
    <p class="p2 col-1 m-r">{{'Pay with' | translate}}</p>
    <ul class="m-t-1 m-t-4-s p-r-4-l left">
        @for(payment of payments; track payment) {
        <li class="inline-flex m-r-2">
            <img [dfImage]="payment.icon"
                 [alt]="payment.name || ''"
                 [height]="24"
                 [width]="36">
        </li>
        }
    </ul>
</div>
}